import React from 'react';
import { HiCheck } from 'react-icons/hi';

import { WIZARD_STEPS, WizardStepId } from './wizardLogic';

export interface WizardStepperProps {
  readonly currentStep: WizardStepId;
  readonly onStepClick: (stepId: WizardStepId) => void;
}

function WizardStepper({
  currentStep,
  onStepClick,
}: WizardStepperProps): JSX.Element {
  const progressPercent =
    WIZARD_STEPS.length > 1
      ? ((currentStep - 1) / (WIZARD_STEPS.length - 1)) * 100
      : 0;

  return (
    <div className="sdm-add-layer-wizard__progress">
      <ol className="sdm-add-layer-wizard__steps" aria-label="Add layer steps">
        {WIZARD_STEPS.map((step) => {
          const isCompleted = currentStep > step.id;
          const isCurrent = currentStep === step.id;
          const canNavigate = step.id < currentStep;

          return (
            <li key={step.id} className="sdm-add-layer-wizard__step-item">
              <button
                type="button"
                className={`sdm-add-layer-wizard__step${
                  isCurrent ? ' sdm-add-layer-wizard__step--current' : ''
                }${isCompleted ? ' sdm-add-layer-wizard__step--completed' : ''}`}
                onClick={() => canNavigate && onStepClick(step.id)}
                disabled={!canNavigate}
                aria-current={isCurrent ? 'step' : undefined}
              >
                <span className="sdm-add-layer-wizard__step-node">
                  <span className="sdm-add-layer-wizard__step-badge">
                    {isCompleted ? <HiCheck /> : step.id}
                  </span>
                </span>
                <span className="sdm-add-layer-wizard__step-label">{step.name}</span>
                <span className="sdm-add-layer-wizard__step-description">
                  {step.description}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
      <div className="sdm-add-layer-wizard__progress-track" aria-hidden>
        <div
          className="sdm-add-layer-wizard__progress-fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
}

export default WizardStepper;
